import r from "./generateUtilityClasses.mjs";
import s from "./generateUtilityClass.mjs";
const o = (i) => s("MuiPickersFadeTransitionGroup", i), a = r("MuiPickersFadeTransitionGroup", ["root"]);
export {
  o as getPickersFadeTransitionGroupUtilityClass,
  a as pickersFadeTransitionGroupClasses
};
//# sourceMappingURL=pickersFadeTransitionGroupClasses.mjs.map
